import React, { createElement, FC, ReactElement, ReactNode } from "react";

import { OrganizationDto } from "@intelligems/ig-types";

import { useGetOrg } from "../../api/organizations/get-organization";
import { useIsAdmin } from "../../api/user-auths/is-admin";
import { NoAccessRoute } from "../../domains/Settings/NoAccessRoute";

interface FeatureRoute2Props {
  adminOnly?: boolean;
  children: any;
  disabledComponent?: ReactNode;
  customTooltip?: ReactElement<any>;
  message?: string;
  debugId: string;
  isEnabled: (org: OrganizationDto, isAdmin: boolean) => boolean;
}

export const ScopedRoute: FC<FeatureRoute2Props> = ({
  adminOnly,
  children,
  disabledComponent,
  customTooltip,
  debugId,
  isEnabled,
  ...props
}) => {
  const org = useGetOrg();
  const isAdmin = useIsAdmin();

  if (isAdmin || isEnabled(org.data.org, isAdmin || false)) {
    return createElement(children);
  }
  return <NoAccessRoute message={"No Access"} />;
};
